// eslint-disable-next-line import/prefer-default-export
export const SELECTABLE_ITEMS = [
  { id: 'yes', display: 'Yes' },
  { id: 'no', display: 'No' },
];
export const SCREENER_STATUSES = {
  NOT_SCREENED: 'not_screened',
  PASSED: 'passed',
  FAILED: 'failed',
};
